import React from "react";
import PropTypes from "prop-types";

import styles from "./pagination.scss";

export const DEFAULT_PAGE = 1;

export default function Pagination({ currentPage, totalPages, length, onPageSelect, variant }) {
  if (totalPages <= 1) return null;

  let startIndex, endIndex, isPreviousActive, isNextActive;
  if (totalPages <= length) {
    startIndex = 1;
    endIndex = totalPages;
  } else {
    startIndex = Math.max(currentPage - Math.floor(length / 2), 1);
    endIndex = Math.min(startIndex + length - 1, totalPages);

    const pageCount = endIndex - startIndex + 1;
    if (pageCount < length) {
      startIndex -= length - pageCount;
    }
  }
  isPreviousActive = currentPage !== 1;
  isNextActive = currentPage !== totalPages;
  const pages = [];
  for (let i = startIndex; i <= endIndex; i++) {
    pages.push(i);
  }

  return (
    <div className={`${styles.pagination} ${styles[variant]}`}>
      <ul>
        <li
          className={`${styles.previous} ${isPreviousActive ? "" : styles.disabled}`}
          key="previous"
          onClick={() => (isPreviousActive ? onPageSelect(currentPage - 1) : null)}
        >
          <span className="material-icons">keyboard_arrow_left</span>
        </li>
        {pages.map((page) => (
          <li className={`${currentPage === page ? styles.active : ""}`} onClick={() => onPageSelect(page)} key={page}>
            <span>{page}</span>
          </li>
        ))}
        <li
          className={`${styles.next} ${isNextActive ? "" : styles.disabled}`}
          key="next"
          onClick={() => (isNextActive ? onPageSelect(currentPage + 1) : null)}
        >
          <span className="material-icons">keyboard_arrow_right</span>
        </li>
      </ul>
    </div>
  );
}

Pagination.defaultProps = {
  currentPage: 1,
  length: 5,
  variant: ""
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  length: PropTypes.number,
  onPageSelect: PropTypes.func,
  variant: PropTypes.oneOf(['', 'oval']),
};
